import {
  Badge,
  type BadgeProps,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@parcel/ui';
import type { StatusMeta } from '../../lib/projects-display.js';

/**
 * A dot + label status badge (stage, lifecycle, …). When a description is
 * present, the badge gets a hover tooltip explaining the value. Self-contained
 * (provides its own TooltipProvider) so it can drop into any table cell or
 * drawer without an ancestor provider.
 */
export function StatusBadge({ label, description, dot, variant, tone }: StatusMeta) {
  // Stage badges carry a shared palette `tone` (Badge renders its colors + dot);
  // disposition / Unknown carry a stock `variant` + dot class.
  const badge = tone ? (
    <Badge tone={tone} dot className="whitespace-nowrap">
      {label}
    </Badge>
  ) : (
    <Badge variant={variant as BadgeProps['variant']} className="whitespace-nowrap">
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden />
      {label}
    </Badge>
  );

  if (!description) return badge;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent className="max-w-xs">{description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
